import { render, staticRenderFns } from "./comprehensive.vue?vue&type=template&id=1df29dba&scoped=true"
import script from "./comprehensive.vue?vue&type=script&lang=js"
export * from "./comprehensive.vue?vue&type=script&lang=js"
import style0 from "./comprehensive.vue?vue&type=style&index=0&id=1df29dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df29dba",
  null
  
)

export default component.exports